import { render, staticRenderFns } from "./body-employers.vue?vue&type=template&id=82355a4e&scoped=true"
import script from "./body-employers.vue?vue&type=script&lang=js"
export * from "./body-employers.vue?vue&type=script&lang=js"
import style0 from "./body-employers.vue?vue&type=style&index=0&id=82355a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82355a4e",
  null
  
)

export default component.exports